(function () {
  var TARGET = '.text-block--Aekp3QzlobE1MTlIxL__text_ccmT4k';

  var targets = [];

  function splitLetters(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    var chars = [];
    nodes.forEach(function (node) {
      var text = node.nodeValue;
      if (!text) return;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < text.length; i++) {
        var ch = text[i];
        if (ch === ' ' || ch === '\n' || ch === '\t') {
          frag.appendChild(document.createTextNode(ch));
        } else {
          var span = document.createElement('span');
          span.className = 'reveal-char';
          span.textContent = ch;
          frag.appendChild(span);
          chars.push(span);
        }
      }
      node.parentNode.replaceChild(frag, node);
    });
    return chars;
  }

  function init() {
    document.querySelectorAll(TARGET + ':not([data-reveal-init])').forEach(function (block) {
      if (!block.textContent.trim()) return;
      block.setAttribute('data-reveal-init', '');
      var chars = splitLetters(block);
      if (chars.length) targets.push({ el: block, chars: chars, last: -1 });
    });
  }

  function update() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    targets.forEach(function (t) {
      var rect = t.el.getBoundingClientRect();
      var h = rect.height;

      var travel = vh + h;
      var scrolled = vh - rect.top;
      var progress = scrolled / (travel * 0.65);
      progress = Math.max(0, Math.min(1, progress));

      // skip work if unchanged (perf)
      if (Math.abs(progress - t.last) < 0.001) return;
      t.last = progress;

      var total = t.chars.length;
      var revealCount = progress * total;
      for (var i = 0; i < total; i++) {
        var cp = revealCount - i;
        cp = cp < 0 ? 0 : (cp > 1 ? 1 : cp);
        t.chars[i].style.opacity = (0.12 + cp * 0.88).toFixed(3);
      }
    });
  }

  function loop() {
    update();
    requestAnimationFrame(loop);
  }

  function boot() {
    init();
    requestAnimationFrame(loop);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function () {
    targets = [];
    boot();
  });
})();